module.exports = __webpack_public_path__ + "images/marketing/home_iphone1.png";